<template>
    <div id="app">
        <AppLoader/>
    </div>
</template>

<script>
    import useQueue from '@/composables/front/queue/useQueue';
    import { uuid } from 'vue-uuid';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        name: 'App',
        created() {
            useHead(process.env.VUE_APP_URL_TITLE)
            this._queue = useQueue({ router: this.$router, route: this.$route });
            this.$store.dispatch('SELECT_GENEROS_CDN');
        },
        beforeDestroy() {
            if (this._queue && this._queue.stop) this._queue.stop();
        },        
        components: {
            AppLoader: () => import(/* webpackPrefetch: true */ '@/AppLoader'),
        },
        mounted() {
            if(this.$route.query.api_token) {
                localStorage.removeItem('token');
                localStorage.setItem('token', this.$route.query.api_token);
            }

            if(! localStorage.getItem('uuid')) {
                localStorage.setItem('uuid', uuid.v4());
            }
        }
    }
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .v--modal-overlay {
        z-index: 9999 !important;
    }
    .popover {
        z-index: 10000 !important;
    }

    /*
     * Fix: invalidar el @keyframes pulse de vue2-dropzone (que hace transform: scale)
     * para que los elementos con tw:animate-pulse usen un keyframe local basado en
     * opacity. Sin esto, el skeleton "rebota" (escala hacia arriba y abajo) después de
     * cargar lazy cualquier vista que importe Dropzone (DocumentosCard, FormFotoEdit,
     * ConfiguracionDeportistas, etc.).
     *
     * Estrategia: sobrescribir el shorthand `animation` COMPLETO con !important para
     * ganar a la regla `animation: var(--tw-animate-pulse) !important` de Tailwind v4,
     * que en `@layer utilities` puede tener prioridad por su posicion en capas.
     *
     * Dropzone sigue usando su propio @keyframes pulse para .dz-progress sin afectarse
     * porque su selector (.dropzone .dz-preview:not(.dz-processing) .dz-progress) es
     * completamente distinto al nuestro (.tw\:animate-pulse).
     */
    @keyframes tw-pulse-skeleton {
        0%, 100% { opacity: 1; }
        50%      { opacity: .5; }
    }
    /*
     * Redefinir la variable CSS --tw-animate-pulse en :root (fuera de @layer) gana
     * a la definición de Tailwind dentro de @layer theme. Asi, todas las utilities
     * `tw:animate-pulse` (que internamente usan animation: var(--tw-animate-pulse))
     * apuntan a nuestro keyframe de opacity en vez del @keyframes pulse de Dropzone
     * (que hace transform: scale).
     */
    :root {
        --tw-animate-pulse: tw-pulse-skeleton 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    }
    .tw\:animate-pulse {
        animation: tw-pulse-skeleton 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
    }
</style>
